(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-emy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('emy-carousel')) {
    customElements.define('emy-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.activeIndex = 0;
        this.autoplayDelay = 2000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.track || this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => {
          this.goTo(this.activeIndex - 1);
          this.restartAutoplay();
        });
        this.nextButton?.addEventListener('click', () => {
          this.goTo(this.activeIndex + 1);
          this.restartAutoplay();
        });
        this.dots.forEach((dot) => dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.index));
          this.restartAutoplay();
        }));
        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { passive: true });
        this.track.addEventListener('pointerup', () => this.startAutoplay(), { passive: true });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.startAutoplay();
        });
        this.handleVisibilityChange = () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };
        this.handleResize = () => this.queueUpdate();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('resize', this.handleResize);
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.reducedMotion || document.hidden || this.slides.length < 2) return;
        this.autoplayTimer = setInterval(() => this.goTo(this.activeIndex + 1), this.autoplayDelay);
      }

      stopAutoplay() {
        if (this.autoplayTimer) clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      goTo(index) {
        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.track.clientWidth * normalizedIndex, behavior: 'smooth' });
        this.setActive(normalizedIndex);
      }

      queueUpdate() {
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => {
          const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
          this.setActive(index);
        });
      }

      setActive(index) {
        this.activeIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
